<div *ngIf="type === 'progress'">
  <div class="ngx-modal-header">
    <h4 class="modal-title pull-left">Bulk Resume Upload Progress</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <h6>{{ progress?.processedResumes > 0 ? 'Processing resumes' : 'Uploading resumes' }}</h6>
    <p class="bu-progress-count">
      {{ progress?.processedResumes }} / {{ progress?.totalResumes }}
      <span class="bu-progress-hint">resumes processed ({{ progress?.uploadedResumes }} uploaded)</span>
    </p>
    <div class="progress bu-progress-bar">
      <div class="progress-bar progress-bar-striped active" role="progressbar"
        [style.width.%]="progressPercentage" [attr.aria-valuenow]="progressPercentage" aria-valuemin="0" aria-valuemax="100">
        {{ progressPercentage }}%
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <p class="text-muted bu-footer-note">
      <i class="fa fa-info-circle"></i> Upload continues in the background. Closing this dialog keeps the progress in the bottom right corner.
    </p>
    <button type="button" class="btn btn-primary" (click)="dismiss()">Close</button>
  </div>
</div>

<div *ngIf="type === 'summary'">
  <div class="ngx-modal-header">
    <h4 class="modal-title pull-left">Bulk Resume Upload Summary</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p class="mb-3" *ngIf="heading" [innerHTML]="heading"></p>
    <div class="bu-banner" [ngClass]="failedFiles.length === 0 ? 'bu-banner-success' : 'bu-banner-warning'">
      <i class="fa bu-banner-icon" [ngClass]="failedFiles.length === 0 ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
      <div>
        <div class="bu-banner-title">
          {{ failedFiles.length === 0 ? 'All files uploaded successfully' : 'Upload completed with failures' }}
        </div>
        <div class="bu-banner-sub"><ng-container *ngIf="folderNames">{{ folderNames }} &middot; </ng-container>{{ summary?.uploadedAt }}</div>
      </div>
    </div>

    <div class="row bu-stats">
      <div class="col-xs-3 text-center">
        <div class="bu-stat-value">{{ summary?.totalFiles }}</div>
        <div class="bu-stat-label">Total Files</div>
      </div>
      <div class="col-xs-3 text-center">
        <div class="bu-stat-value bu-success">{{ summary?.successfulFiles }}</div>
        <div class="bu-stat-label">Successful</div>
      </div>
      <div class="col-xs-3 text-center">
        <div class="bu-stat-value bu-failed">{{ summary?.failedFiles }}</div>
        <div class="bu-stat-label">Failed</div>
      </div>
      <div class="col-xs-3 text-center">
        <div class="bu-stat-value bu-success">{{ successPercentage }}%</div>
        <div class="bu-stat-label">Success Rate</div>
      </div>
    </div>

    <div *ngIf="candidates.length > 0">
      <h5 class="bu-section-title">Processed Candidates ({{ candidates.length }})</h5>
      <div class="bu-table-wrap">
        <table class="table table-bordered bu-table">
          <thead>
            <tr>
              <th class="text-center" style="width: 40px;">No.</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th class="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let candidate of candidates; let i = index">
              <td class="text-center">{{ i + 1 }}</td>
              <td>{{ candidate.firstName }} {{ candidate.lastName }}</td>
              <td>{{ candidate.email || '-' }}</td>
              <td>{{ candidate.phone || '-' }}</td>
              <td class="text-center">
                <span class="label" [ngClass]="candidate.newCandidate ? 'label-success' : 'label-info'">
                  {{ candidate.newCandidate ? 'New' : 'Update' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="failedFiles.length > 0">
      <h5 class="bu-section-title">Failed Files ({{ failedFiles.length }})</h5>
      <div class="bu-table-wrap">
        <table class="table table-bordered bu-table">
          <thead>
            <tr>
              <th class="text-center" style="width: 40px;">No.</th>
              <th>File Name</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of failedFiles; let i = index">
              <td class="text-center">{{ i + 1 }}</td>
              <td>{{ file.fileName || '-' }}</td>
              <td>{{ file.reason || file.error || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="close()">Close</button>
  </div>
</div>
